import { PostsSpace } from "./space.interface";

export enum SCREEN_TYPES {
    TASK_COMMENTS = "task_comments",
    TASK_DOCUMENTS = "task_documents",
    TASK_SUMMARY = "task_summary"
}

export interface SharedEvent {
    type: SCREEN_TYPES
    action: string;
    data: any;
}

export interface SharedData {
    screenType: SCREEN_TYPES;
    postsSpace: PostsSpace;
}